import { Breadcrumb, BreadcrumbIcon, BreadcrumbLink, BreadcrumbPage } from '@ads/components-react';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface PersonEditTemplateProps {
  readonly title: string;
  readonly children: ReactNode;
}

export function PersonEditTemplate({ title, children }: PersonEditTemplateProps) {
  const { t } = useTranslation('personManagement');

  return (
    <div className="flex flex-col gap-nano">
      <Breadcrumb>
        <BreadcrumbLink>
          <Link to="/">
            {' '}
            <BreadcrumbIcon />
          </Link>
        </BreadcrumbLink>
        <BreadcrumbLink>
          <Link to="/persons">{t('breadcrumb.persons')}</Link>
        </BreadcrumbLink>
        <BreadcrumbPage>{title}</BreadcrumbPage>
      </Breadcrumb>

      <h1 className="ts-heading-lg text-ctx-content-title">{title}</h1>

      <div className="rounded-md my-xxs border-hairline border-ctx-layout-border bg-ctx-layout-surface p-md shadow-level1">
        {children}
      </div>
    </div>
  );
}
